// Yup
import { object, number, string, array } from 'yup';

const benefitSchema = object().shape({
  settings: object().shape({
    name: string().required('Campo nome obrigatório'),
    startDate: string()
      .required('Campo data de início obrigatório')
      .matches(
        /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/g,
        'Digite uma data válida',
      ),
    endDate: string()
      .required('Campo data de término obrigatório')
      .matches(
        /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/g,
        'Digite uma data válida',
      ),
    benefit: object().shape({
      value: number()
        .required('Campo desconto obrigatório')
        .min(0, 'Valor inválido')
        .typeError('Valor inválido'),
    }),
    profile: object().shape({
      profiles: array().min(1, 'Adicione pelo menos um perfil'),
    }),
  }),
  timing: object().shape({
    weekDay: object().shape({
      weekDay: array().min(1, 'Adicione pelo menos um dia da semana'),
    }),
    timeRange: object().shape({
      hours: array().of(
        object().shape({
          start: string().required('Obrigatório'),
          end: string().required('Obrigatório'),
        }),
      ),
    }),
  }),
  limitations: object().shape({
    counting: object().shape({
      count: number().when('needed', {
        is: true,
        then: number()
          .required('Obrigatório')
          .integer('Valor inválido')
          .min(0, 'Valor inválido')
          .typeError('Valor inválido'),
      }),
      time: number().when('needed', {
        is: true,
        then: number()
          .required('Obrigatório')
          .integer('Valor inválido')
          .min(0, 'Valor inválido')
          .typeError('Valor inválido'),
      }),
    }),
    daily: object().shape({
      count: number().when('needed', {
        is: true,
        then: number()
          .required('Obrigatório')
          .integer('Valor inválido')
          .min(0, 'Valor inválido')
          .typeError('Valor inválido'),
      }),
    }),
  }),
  integration: object().shape({
    integrations: array().when('needed', {
      is: true,
      then: array().of(
        object().shape({
          duration: number()
            .required('Obrigatório')
            .integer('Valor inválido')
            .min(0, 'Valor inválido')
            .typeError('Valor inválido'),
          providers: array().of(
            object().shape({
              company: string().required('Campo obrigatório'),
              value: number()
                .required('Obrigatório')
                .min(0, 'Valor inválido')
                .typeError('Valor inválido'),
            }),
          ),
        }),
      ),
    }),
  }),
  dailyBlockLimitation: object().shape({
    periodBlock: array()
      .of(
        object().shape({
          start: string(),
          end: string(),
        }),
      )
      .nullable(),
  }),
});

export default benefitSchema;
export { benefitSchema };
